export enum LocalesEnum {
  RU = 'ru-RU',
  KZ = 'kk-KZ',
  DEBUG = 'dbg',
}

export const LOCALE_DEFAULT = LocalesEnum.RU;

const baseTranslateUrl = './assets/i18n';
export const LOCALE_MODULES = [
  { baseTranslateUrl },
  { baseTranslateUrl, moduleName: 'login' },
  { baseTranslateUrl, moduleName: 'main' },
  { baseTranslateUrl, moduleName: 'partners' },
  { baseTranslateUrl, moduleName: 'reports' },
  { baseTranslateUrl, moduleName: 'master-franchise' },
  { baseTranslateUrl, moduleName: 'application' },
  { baseTranslateUrl, moduleName: 'employees' },
  { baseTranslateUrl, moduleName: 'notification' },
  { baseTranslateUrl, moduleName: 'control' },
  { baseTranslateUrl, moduleName: 'franchise' },
  { baseTranslateUrl, moduleName: 'company' },
  { baseTranslateUrl, moduleName: 'country' },
  { baseTranslateUrl, moduleName: 'survey' },
];
